/* 🤖 this file was generated by svg-to-ts */
export const matIconAlignHorizontalLeft: {
  name: 'align-horizontal-left';
  data: string;
} = {
  name: 'align-horizontal-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z"/></svg>`
};
